module.exports = __webpack_public_path__ + "img/alpop-icon.7575c677.png";